import axios from 'axios'

export default async (context, locale) => {
  const { data } = await axios.get(`${process.env.apiURL}/translations/${locale}`)
  return data
}
